// eslint-disable-next-line import/prefer-default-export
export const getBusinessConfig = ({ businessConfig }, key) => businessConfig.company[key];
